import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import VoidCivilUnionForm from './form';
import {
  NewPersonVM,
  AccordionVoidCivilUnion,
} from 'shell/components/shared/sipo-person-form/new-person';

const VoidCivilUnionComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldVoidCivilUnionChange = useEventCallback(
    (
      key: keyof AccordionVoidCivilUnion,
      value: AccordionVoidCivilUnion[keyof AccordionVoidCivilUnion]
    ) => {
      formContext.setFieldValue('voidCivilUnion', {
        ...formContext.values.voidCivilUnion,
        [key]: value,
      });
    }
  );

  const onFieldsVoidCivilUnionChange = useEventCallback((values: AccordionVoidCivilUnion) => {
    formContext.setFieldValue('voidCivilUnion', {
      ...formContext.values.voidCivilUnion,
      ...values,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-void-civil-union-content"
        id="panel-person-void-civil-union-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Annullamento Unione Civile
          {formContext?.errors?.voidCivilUnion && formContext?.touched?.voidCivilUnion ? (
            <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
              Attenzione verificare dati errati o mancanti
            </Typography>
          ) : undefined}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <VoidCivilUnionForm
          values={formContext.values.voidCivilUnion}
          onChange={onFieldVoidCivilUnionChange}
          onFieldsChange={onFieldsVoidCivilUnionChange}
          errors={formContext.errors.voidCivilUnion as FormikErrors<AccordionVoidCivilUnion>}
          touched={
            formContext.touched.voidCivilUnion as unknown as FormikTouched<AccordionVoidCivilUnion>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

VoidCivilUnionComponent.displayName = 'Accordion void Civil Union component';

const VoidCivilUnion = memo(VoidCivilUnionComponent);

export default VoidCivilUnion;
